/* =====================================================================
   Signage.inc  |  SIGN CATEGORIES & SIGN TYPES  (single source of truth)
   ---------------------------------------------------------------------
   Every page that shows categories or sign types reads this file:
   home, /pages/sign-categories, /pages/sign-category?cat=<id>, quote page.
   Edit it here and the change shows up everywhere.

   - categories: order here = order on the site. `id` is the ?cat= value.
     `cardImg` (optional) is the photo on the category card; without it the card uses `cover`.
     `aliases` are older ids/slugs that still resolve to the category.
     Each entry in `types` points at a sign type below and may override
     its `name`, `img`, `desc` and `gallery` (its "View Designs" photos) for that category only.
   - types: shared sign types. tags[0] is "Lit" or "Non-Lit" (badge).
     `mockup` is the quote-form mockup card the type preselects.
   - gallery: extra images per sign type for "View Designs" (all are shown).
   - images: image URL -> [width, height]. Every image field (img, cardImg, cover, hero, gallery) is a complete
     URL, from any host and in any format, used exactly as written. Shopify-hosted images are fetched at 640px
     for small spots (sign cards, photo strip). Adding a new image: put its URL in the field and add the URL here
     with its [width, height] so the page does not jump while it loads (optional).

   Copy rule from the brief: "backlit" and "acrylic" only ever as
   "3D backlit" / "3D acrylic".
   ===================================================================== */
window.SG_SIGN_DATA = {
  categories: [
    {
      "id": "storefronts",
      "aliases": [
        "storefront",
        "storefront-signs"
      ],
      "name": "Storefront Signs",
      "sub": "Outdoor Building Signage",
      "cardDesc": "Bright storefront signs and 3d signs built to your logo, from light boxes to letters, made by a storefront sign maker.",
      "cover": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-front-lit-pizzeria.webp",
      "cardImg": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-card.png?v=1791347772",
      "hero": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-channel-letters-coffee.webp",
      "h1": "Storefront Signs",
      "h1em": "Outdoor Building Signage",
      "metaTitle": "Storefront Signs | Custom Storefront Signage | Signage.inc",
      "metaDesc": "Custom storefront signs from a storefront sign maker: 3D acrylic, 3D metal backlit, lightbox and push-through signs. Free mockup in 2 hours.",
      "intro": "Your storefront works day and night. Choose storefront signage, storefront channel letters or exterior storefront channel letters that glow after dark and read clearly by day.",
      "types": [
        {
          "type": "3d-acrylic-double-lit",
          "name": "3D Acrylic Doublelit Signs",
          "desc": "Letters glow through the face and halo the wall, 3d illuminated signs for custom storefront signs.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-6.png?v=1791347821",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-1.jpg?v=1791347787",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-2.jpg?v=1791347793",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-3.png?v=1791347801",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-4.jpg?v=1791347806",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-5.jpg?v=1791533507?v=1791347814",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-7.png?v=1791347829",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-8.png?v=1791347836",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-card.png?v=1791347772"
          ]
        },
        {
          "type": "3d-acrylic-lit-letters",
          "name": "3D Acrylic Frontlit Signs",
          "desc": "Lit 3d acrylic signage makes crisp storefront signs, also known as storefront channel letters.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-1.png?v=1791347843",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-2.png?v=1791347849",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/image_19_df60aece-a2bf-4fdf-ba28-6d249589e765.png?v=1791533311?v=1791347856",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-4.png?v=1791347863",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-5.png?v=1791347870",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-6.png?v=1791347877",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-7.png?v=1791347884"
          ]
        },
        {
          "type": "3d-metal-backlit-letters",
          "name": "3D Metal Backlit Signs",
          "desc": "Halo lit 3D metal letters, premium storefront signage and store front signs for upscale shops.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-1.png?v=1791347891",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-2.png?v=1791347898",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-3.png?v=1791347905",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-4.png?v=1791347912",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-5.png?v=1791347919",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-7.png?v=1791347926",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-8.png?v=1791347934",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-9.png?v=1791347941",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-10.png?v=1791347948",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-11.png?v=1791347955",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-12.png?v=1791347962",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-13.png?v=1791347969",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-14.png?v=1791347975",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-15.png?v=1791347982"
          ]
        },
        {
          "type": "light-box-single",
          "name": "Single Sided Lightbox Signs",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-4.jpg?v=1791348005",
          "desc": "A flat lit cabinet that shows your whole logo, a simple store front sign or custom store front sign.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-1.jpg?v=1791347988",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-2.jpg?v=1791347994",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-3.jpg?v=1791348000",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-5.jpg?v=1791348012",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-6.jpg?v=1791348018",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-7.jpg?v=1791348024",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-8.jpg?v=1791348030",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-9.jpg?v=1791348037",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-10.jpg?v=1791348043",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-11.jpg?v=1791348049",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-12.png?v=1791348057"
          ]
        },
        {
          "type": "push-thru",
          "name": "Push Through Signs",
          "desc": "Only the letters glow, a sharp illuminated storefront sign or custom storefront sign.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-05-push-through-signs-2.png?v=1791348070",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-05-push-through-signs-1.png?v=1791348063"
          ]
        },
        {
          "type": "3d-metal-nonlit",
          "name": "3D Metal Non Lit Signs",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-06-3d-metal-non-lit-signs-4.png?v=1791348094",
          "desc": "Brushed, polished or painted letters with no wiring, a lasting 3d metal sign for storefront walls.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-06-3d-metal-non-lit-signs-1.jpg?v=1791348075",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-06-3d-metal-non-lit-signs-2.jpg?v=1791348082",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-06-3d-metal-non-lit-signs-3.jpg?v=1791348087"
          ]
        },
        {
          "type": "metal-2d",
          "name": "2D Metal Non Lit Signs",
          "desc": "Flat cut letters and logos with crisp edges and no wiring, slim signs for storefront entrances.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-07-2d-metal-non-lit-signs-2.jpg?v=1791348100",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-06-3d-metal-non-lit-signs-1.jpg?v=1791348075",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-07-2d-metal-non-lit-signs-3.jpg?v=1791348106",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-07-2d-metal-non-lit-signs-4.jpg?v=1791348112",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-07-2d-metal-non-lit-signs-5.jpg?v=1791348118",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-07-2d-metal-non-lit-signs-6.jpg?v=1791348124"
          ]
        },
        {
          "type": "3d-acrylic-lit-backboard",
          "name": "3D Acrylic Frontlit Signs with Backboard",
          "desc": "Front lit 3D acrylic letters on a backboard with hidden wiring, tidy store front signs for business.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-3.png?v=1791348145",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-1.jpg?v=1791348130",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-2.png?v=1791348138"
          ]
        },
        {
          "type": "3d-acrylic-lit-raceway",
          "name": "3D Acrylic Frontlit Signs with Raceway",
          "desc": "Front lit 3d acrylic signs on a raceway, for outdoor storefront signs or exterior storefront signs.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-2.jpg?v=1791348157",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-1.jpg?v=1791348151",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-2.jpg?v=1791348157",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-3.jpg?v=1791348163",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-5.png?v=1791348176"
          ]
        },
        {
          "type": "3d-metal-backlit-backboard",
          "name": "3D Metal Backlit Signs with Backboard",
          "desc": "Halo lit 3D metal letters on a backboard, built by a storefront sign maker who hides every wire.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-2.png?v=1791348190",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-1.jpg?v=1791348182",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-3.png?v=1791348196",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-4.png?v=1791348204"
          ]
        },
        {
          "type": "3d-backlit-raceway",
          "name": "3D Metal Backlit Signs with Raceway",
          "desc": "Halo lit 3D metal letters on a raceway, a quick-install storefront sign for business.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-4.png?v=1791348233",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-1.png?v=1791348211",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-2.png?v=1791348219",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-3.png?v=1791348226"
          ]
        },
        {
          "type": "3d-nonlit-backboard",
          "name": "3D Metal Non Lit Signs with Backboard",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-12-3d-metal-non-lit-signs-with-backboard-2.png?v=1791348246",
          "desc": "Unlit 3D letters on a backboard, clean storefront signs for business and business store front signs.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-12-3d-metal-non-lit-signs-with-backboard-1.jpg?v=1791348238"
          ]
        }
      ],
      "whys": [
        [
          "Seen day and night",
          "Illumination options chosen for street-level visibility long after dark."
        ],
        [
          "Permit-ready drawings",
          "Dimensioned drawings you can hand straight to your landlord or city."
        ],
        [
          "Free mockup on your building",
          "See the sign on a photo of your facade before you commit."
        ],
        [
          "2-year warranty",
          "Every component is covered for two full years."
        ]
      ],
      "faqs": [
        [
          "What are the best storefront signs for a shop front?",
          "Custom storefront signs work best when they match your wall and street. 3D acrylic doublelit or 3D metal backlit letters read well at night, and a single sided lightbox is a simple, bright choice. As a storefront sign maker we recommend a style in your free mockup."
        ],
        [
          "Do you make exterior storefront signs with lighting?",
          "Yes. Exterior storefront signs can be lit from the face, from behind or both. An illuminated storefront sign, such as a push through sign, keeps your shop visible long after dark."
        ],
        [
          "What is the difference between storefront signage and a sign for storefront windows?",
          "A sign for storefront use is any sign fixed to the building front. Storefront signage usually combines a main sign above the entrance with signs for storefront entrances, and we can plan them as one matching set."
        ],
        [
          "Can storefront signs be customized to match my brand?",
          "Yes! Custom storefront signs can feature your preferred colors, fonts, and dimensions. From illuminated storefront signs to 3D storefront signage, every sign can match your brand identity."
        ],
        [
          "How long does a storefront sign take?",
          "After you approve your mockup, production and delivery typically take 10-15 business days, with free delivery across the US."
        ]
      ]
    },
    {
      "id": "indoor",
      "aliases": [
        "indoor",
        "indoor-signs"
      ],
      "name": "3D Interior Signs",
      "sub": "Interior Business Signage",
      "cardDesc": "Logo walls and lit lettering that make lobbies and offices feel established, from business signs indoor to custom interior signs.",
      "cover": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-reception-logo-wall-boutique.webp",
      "hero": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-logo-lobby.webp",
      "h1": "3D Interior Signs",
      "h1em": "Interior Business Signage",
      "metaTitle": "Interior Signs | Business Signs Indoor | Signage.inc",
      "metaDesc": "Interior Signs for Business and custom indoor signs for business: 3D acrylic front lit, 3D metal backlit, lightbox, push-through and flatcut signs. Free mockup.",
      "intro": "Visitors judge your business within seconds of walking in. A 3D logo or custom indoor channel letters for business behind reception show you are established.",
      "types": [
        {
          "type": "3d-acrylic-lit-letters",
          "name": "3D Acrylic Frontlit Signs",
          "desc": "Lit 3D acrylic faces bring a bright logo to reception, a bold choice for business signs indoor.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-01-3d-acrylic-frontlit-signs-3.jpg?v=1791348270",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-01-3d-acrylic-frontlit-signs-1.jpg?v=1791348257",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-01-3d-acrylic-frontlit-signs-2.png?v=1791348265"
          ]
        },
        {
          "type": "3d-metal-backlit-letters",
          "name": "3D Metal Backlit Signs",
          "desc": "Soft halo glow for lobby walls, halo lit signs and 3d metal signs for businesses with no glare.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-02-3d-metal-backlit-signs-2.jpg?v=1791348276",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-card.jpg?v=1791348251"
          ]
        },
        {
          "type": "light-box-single",
          "name": "Lightbox Signs",
          "desc": "Flat, evenly lit illuminated sign cabinets, simple custom lighted signs for business offices.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-03-lightbox-signs-1.jpg?v=1791348281",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-03-lightbox-signs-2.jpg?v=1791348287"
          ]
        },
        {
          "type": "push-thru",
          "name": "Push Through Signs",
          "desc": "A lit cabinet with pushed-through letters, crisp illuminated signage for receptions and shops.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-04-push-through-signs-1.jpg?v=1791348293",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-04-push-through-signs-2.jpg?v=1791348298"
          ]
        },
        {
          "type": "3d-metal-nonlit",
          "name": "3D Metal Non Lit Signs",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-05-3d-metal-non-lit-signs-3.jpg?v=1791348315",
          "desc": "Brushed, polished or painted 3d signs, a timeless 3d metal logo sign behind reception.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-05-3d-metal-non-lit-signs-1.jpg?v=1791348304",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-05-3d-metal-non-lit-signs-2.jpg?v=1791348309"
          ]
        },
        {
          "type": "metal-2d",
          "name": "Flatcut Signs",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-06-flatcut-signs-2.jpg?v=1791348327",
          "desc": "Flat cut lettering with crisp edges and no wiring, a clean option for custom interior signs.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-06-flatcut-signs-1.jpg?v=1791348321",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-06-flatcut-signs-3.jpg?v=1791348333",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-06-flatcut-signs-4.jpg?v=1791348339"
          ]
        },
        {
          "type": "laser-cut",
          "name": "Lasercut Signs",
          "desc": "Laser cut shapes and lettering with sharp detail, ideal for an interior business sign.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-07-lasercut-signs-1.jpg?v=1791348344",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-07-lasercut-signs-2.jpg?v=1791348350",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-07-lasercut-signs-3.jpg?v=1791348356"
          ]
        },
        {
          "type": "3d-acrylic-lit-backboard",
          "name": "3D Acrylic Frontlit Signs with Backboard",
          "desc": "Front lit 3D acrylic letters on a backboard, ready to hang as custom indoor signs for business.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-08-3d-acrylic-frontlit-signs-with-backboard-2.png?v=1791348371",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-08-3d-acrylic-frontlit-signs-with-backboard-1.png?v=1791348364",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-08-3d-acrylic-frontlit-signs-with-backboard-3.png?v=1791348378"
          ]
        },
        {
          "type": "3d-metal-backlit-backboard",
          "name": "3D Metal Backlit Signs with Backboard",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-09-3d-metal-backlit-signs-with-backboard-3.jpg?v=1791348396",
          "desc": "Halo lit 3D metal letters on a backboard, custom indoor channel letters for business lobbies.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-09-3d-metal-backlit-signs-with-backboard-1.jpg?v=1791348383",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-09-3d-metal-backlit-signs-with-backboard-3.jpg?v=1791348396",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-09-3d-metal-backlit-signs-with-backboard-4.jpg?v=1791348401"
          ]
        }
      ],
      "whys": [
        [
          "Premium finishes",
          "Brushed, polished, gold, black and painted metals plus custom colors."
        ],
        [
          "No-drill options",
          "Adhesive and concealed mounting for leased offices and window walls."
        ],
        [
          "Free mockup on your wall",
          "Send a photo of your wall and see the sign on it first."
        ],
        [
          "Unlimited revisions",
          "Adjust size, font and finish until it looks exactly right."
        ]
      ],
      "faqs": [
        [
          "What are the best business signs indoor?",
          "For a lobby or reception wall, 3D metal backlit signs give a soft glow and 3D metal non lit signs need no wiring. Our business signs indoor range also includes lightbox, push through, flatcut and lasercut signs."
        ],
        [
          "Can you make custom interior signs for reception?",
          "Yes. Custom interior signs and an interior business sign for your reception area can be made in flatcut or lasercut metal, with finishes and colors matched to your brand."
        ],
        [
          "Are custom indoor signs for business lit or non lit?",
          "Both. Choose 3D acrylic front lit signs for a bright logo, or non lit metal for a quiet look. Custom indoor signs for business can also sit on a backboard so nothing is drilled into a leased wall."
        ],
        [
          "Can a lightbox or push through sign be used indoors?",
          "Yes. Lightbox signs mount flat on the wall, and a push through sign gives crisp lettering on a lit face. We confirm size and position in your free mockup."
        ],
        [
          "What file formats do you need for my logo?",
          "Vector files (AI, EPS, SVG, PDF) are ideal, but a clear PNG or JPG is enough to start. We will redraw it for fabrication at no cost."
        ]
      ],
      "cardImg": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-card.jpg?v=1791348251"
    },
    {
      "id": "outdoor",
      "aliases": [
        "outdoor",
        "outdoor-signs"
      ],
      "name": "Outdoor Signs",
      "sub": "Exterior Signage",
      "cardDesc": "Weather-sealed business signs outdoor, from custom business signs outdoor to outdoor channel letters for business.",
      "cover": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-letters-exterior-wall.webp",
      "hero": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-blue-night.webp",
      "h1": "Outdoor Signs",
      "h1em": "Exterior Signage",
      "metaTitle": "Outdoor Signs | Exterior Business Signs | Signage.inc",
      "metaDesc": "Outdoor business signs and exterior signage: lighted outdoor signs for business in 3D acrylic front lit, 3D metal backlit and lightbox styles. Free mockup.",
      "intro": "Our exterior signs face sun, rain, wind and snow every day. These outdoor business signs use outdoor-rated materials and sealed LEDs, from exterior building channel letters to exterior channel letter signage.",
      "types": [
        {
          "type": "3d-acrylic-lit-letters",
          "name": "3D Acrylic Front Lit",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-7.png?v=1791347884",
          "desc": "Front lit 3D acrylic letters with weather-sealed LEDs, easy-to-read business signs outdoor.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-1.png?v=1791347843",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-2.png?v=1791347849",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/image_19_df60aece-a2bf-4fdf-ba28-6d249589e765.png?v=1791533311?v=1791347856",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-4.png?v=1791347863",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-5.png?v=1791347870",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-6.png?v=1791347877"
          ]
        },
        {
          "type": "3d-metal-backlit-letters",
          "name": "3D Metal Backlit Signs",
          "desc": "3D metal outdoor backlit signs that halo brick or stucco, premium custom business signs outdoor.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-12.png?v=1791347962",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-1.png?v=1791347891",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-2.png?v=1791347898",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-3.png?v=1791347905",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-4.png?v=1791347912",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-5.png?v=1791347919",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-7.png?v=1791347926",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-8.png?v=1791347934",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-9.png?v=1791347941",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-10.png?v=1791347948",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-11.png?v=1791347955",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-13.png?v=1791347969",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-14.png?v=1791347975",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-15.png?v=1791347982"
          ]
        },
        {
          "type": "light-box-single",
          "name": "Wall Mounted Lightbox",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-7.jpg?v=1791348024",
          "desc": "A weather-sealed cabinet lit from inside, simple light box signs outdoor and exterior signs.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-1.jpg?v=1791347988",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-2.jpg?v=1791347994",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-3.jpg?v=1791348000",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-4.jpg?v=1791348005",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-5.jpg?v=1791348012",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-6.jpg?v=1791348018",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-8.jpg?v=1791348030",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-9.jpg?v=1791348037",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-10.jpg?v=1791348043",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-11.jpg?v=1791348049",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-12.png?v=1791348057"
          ]
        },
        {
          "type": "light-box-double",
          "name": "Double Sided Light Box",
          "desc": "A lit cabinet seen from both directions, outdoor business signs for buildings on busy corners.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-outdoor-signs-04-double-sided-light-box-3.jpg?v=1791348419",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-outdoor-signs-04-double-sided-light-box-1.jpg?v=1791348408",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-outdoor-signs-04-double-sided-light-box-2.jpg?v=1791348413",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-outdoor-signs-04-double-sided-light-box-4.jpg?v=1791348425"
          ]
        },
        {
          "type": "push-thru",
          "name": "Push Through Sign",
          "desc": "Only the letters glow through the face, bold outdoor lighted signs for business at night.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-05-push-through-signs-1.png?v=1791348063",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-05-push-through-signs-2.png?v=1791348070"
          ]
        },
        {
          "type": "hollow-cut",
          "name": "Hollow Cut Signs",
          "desc": "Open-center letters lit through and around the edge, striking outdoor business signs at night."
        },
        {
          "type": "3d-acrylic-lit-backboard",
          "name": "3D Acrylic Front Lit with Backboard",
          "desc": "Front lit 3D acrylic letters on a backboard, tidy outdoor signs for business on uneven walls.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-2.png?v=1791348138",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-1.jpg?v=1791348130",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-3.png?v=1791348145"
          ]
        },
        {
          "type": "3d-acrylic-lit-raceway",
          "name": "3D Acrylic Front Lit with Raceway",
          "desc": "Front lit 3d acrylic signs on one raceway, quick-install outdoor lettering for buildings.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-2.jpg?v=1791348157",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-1.jpg?v=1791348151",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-3.jpg?v=1791348163",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-4.jpg?v=1791348168",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-5.png?v=1791348176"
          ]
        },
        {
          "type": "3d-metal-backlit-backboard",
          "name": "3D Metal Backlit with Backboard",
          "desc": "Halo lit 3D letters on a backboard, ready-to-bolt exterior building signs or a custom exterior sign.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-4.png?v=1791348204",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-1.jpg?v=1791348182",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-2.png?v=1791348190",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-3.png?v=1791348196"
          ]
        },
        {
          "type": "3d-backlit-raceway",
          "name": "3D Metal Backlit with Raceway",
          "desc": "Halo lit 3D letters on a raceway, quick outdoor building signs for business on brick or siding.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-2.png?v=1791348219",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-1.png?v=1791348211",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-3.png?v=1791348226",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-4.png?v=1791348233"
          ]
        },
        {
          "type": "commercial-exterior",
          "name": "Commercial Outdoor Signs",
          "desc": "Built-to-spec commercial outdoor signs, business outdoor signs and custom exterior business signs.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-2.png?v=1791347898",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-1.png?v=1791347891",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-3.png?v=1791347905",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-4.png?v=1791347912",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-5.png?v=1791347919",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-7.png?v=1791347926",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-8.png?v=1791347934",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-9.png?v=1791347941",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-10.png?v=1791347948",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-11.png?v=1791347955",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-12.png?v=1791347962",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-13.png?v=1791347969",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-14.png?v=1791347975",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-15.png?v=1791347982"
          ]
        },
        {
          "type": "exterior-lighted",
          "name": "Exterior Storefront Sign",
          "desc": "A weather-sealed lit sign for shop fronts, part of our exterior signage and exterior business signs.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-7.png?v=1791347829",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-1.jpg?v=1791347787",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-2.jpg?v=1791347793",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-3.png?v=1791347801",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-4.jpg?v=1791347806",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-5.jpg?v=1791533507?v=1791347814",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-6.png?v=1791347821",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-8.png?v=1791347836",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-card.png?v=1791347772"
          ]
        }
      ],
      "whys": [
        [
          "Weather-rated build",
          "Sealed LEDs and outdoor materials for sun, rain, wind and snow."
        ],
        [
          "Built for distance",
          "Letter heights and brightness specified for readability from the road."
        ],
        [
          "Free mockup on your building",
          "See it on your facade before you commit."
        ],
        [
          "Multi-location rollouts",
          "Consistent signs and one point of contact across sites."
        ]
      ],
      "faqs": [
        [
          "Which outdoor business signs last in bad weather?",
          "All of our outdoor business signs use sealed LEDs and outdoor-rated finishes. Lighted outdoor signs for business, such as 3D acrylic front lit letters and a wall mounted lightbox, are made for rain, sun and snow."
        ],
        [
          "What are the best outdoor signs for business visibility?",
          "Outdoor signs for business that face a road work best when lit. Lighted signs such as a push through sign, or 3D metal backlit signs that throw a halo on the wall, stand out at night. Tell us the viewing distance and we will suggest letter heights."
        ],
        [
          "Do you make exterior signage for whole buildings?",
          "Yes. Exterior signage, exterior building signs and exterior signs for plazas are built to your drawings. Commercial outdoor signs and an exterior storefront sign can be supplied as a matching set."
        ],
        [
          "Can you mount outdoor building signs for business on brick or stucco?",
          "Yes. Outdoor building signs for business are mounted with the right fasteners, directly or on a backboard or raceway, and every order includes a drilling template and mounting guidance."
        ],
        [
          "Do you handle multi-location orders?",
          "Yes. We keep your artwork and specs on file so each location gets an identical sign, with volume pricing for larger orders."
        ]
      ],
      "cardImg": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-6.png?v=1791347877"
    },
    {
      "id": "restaurants",
      "aliases": [
        "corporate",
        "corporate-restaurant-signs"
      ],
      "name": "Corporate & Restaurant Signs",
      "sub": "Commercial Signage",
      "cardDesc": "Polished corporate signage and commercial signage for offices, restaurants and retail, from one commercial sign company.",
      "cover": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-letters-cafe.webp",
      "hero": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-lit-logo-pizzeria.webp",
      "h1": "Corporate & Restaurant Signs",
      "h1em": "Commercial Signage",
      "metaTitle": "Corporate & Restaurant Signs | Signage.inc",
      "metaDesc": "Corporate signage and custom commercial signs for business: halo lit channel letters, front-lit, lightbox and push-through signs. Free mockup in 2 hours.",
      "intro": "Head office or new dining room, your sign sets the first impression. We build commercial signs for business and building channel letters for business that read from the sidewalk.",
      "types": [
        {
          "type": "corporate-front-lit",
          "name": "Corporate Front-Lit Signs",
          "desc": "Face-lit letters for office buildings, clean corporate signage and building signs for business.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-01-corporate-front-lit-signs-3.jpg?v=1791348449",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-01-corporate-front-lit-signs-1.jpg?v=1791348437",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-01-corporate-front-lit-signs-2.jpg?v=1791348443"
          ]
        },
        {
          "type": "halo-lit-channel",
          "name": "Halo Lit Channel Letters",
          "desc": "Letters that glow onto the wall behind, halo lit channel letters with an upscale, glare-free look.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-02-halo-lit-channel-letters-2.jpg?v=1791348460",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-02-halo-lit-channel-letters-1.jpg?v=1791348454",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-card.jpg?v=1791348431"
          ]
        },
        {
          "type": "3d-metal-nonlit",
          "name": "3D Metal Non Lit",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-05-3d-metal-non-lit-signs-1.jpg?v=1791348304",
          "desc": "Brushed or painted 3d signs for business with no lighting, solid 3d metal business signs.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-06-3d-metal-non-lit-signs-1.jpg?v=1791348075",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-05-3d-metal-non-lit-signs-1.jpg?v=1791348304",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-06-3d-metal-non-lit-signs-3.jpg?v=1791348087",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-05-3d-metal-non-lit-signs-2.jpg?v=1791348309",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-05-3d-metal-non-lit-signs-3.jpg?v=1791348315",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-06-3d-metal-non-lit-signs-4.png?v=1791348094"
          ]
        },
        {
          "type": "push-thru",
          "name": "Push Thru Signage",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-04-push-thru-signage-1.png?v=1791348474",
          "desc": "Pushed-through letters with strong night contrast, illuminated signs for businesses and diners.",
          "gallery": []
        },
        {
          "type": "light-box-double",
          "name": "Double Sided Light Box",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-05-double-sided-light-box-2.jpg?v=1791441393",
          "desc": "A two-way lit cabinet, an led business sign or illuminated business signs for corners.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-05-double-sided-light-box-1.jpg?v=1791348479"
          ]
        },
        {
          "type": "corporate-signage",
          "name": "Corporate Signage",
          "desc": "Brand-accurate signs for head offices, from a single corporate sign to corporate office signs.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-06-corporate-signage-1.png?v=1791348492",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-06-corporate-signage-2.png?v=1791348498"
          ]
        },
        {
          "type": "commercial-signage",
          "name": "Commercial Signage",
          "desc": "Built-to-drawing commercial signage and custom commercial signs from one commercial sign company.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-07-commercial-signage-1.png?v=1791348506",
          "gallery": []
        },
        {
          "type": "3d-metal-backlit-backboard",
          "name": "3D Metal Backlit with Backboard",
          "desc": "Halo lit 3d business signs on a backboard, neat commercial signs for business and restaurants.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-1.jpg?v=1791348182",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-2.png?v=1791348190",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-3.png?v=1791348196",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-4.png?v=1791348204"
          ]
        },
        {
          "type": "3d-backlit-raceway",
          "name": "3D Metal Backlit with Raceway",
          "desc": "Halo lit 3D metal letters on a raceway, tidy 3d metal signs for business with hidden wiring.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-3.png?v=1791348226",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-1.png?v=1791348211",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-2.png?v=1791348219",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-4.png?v=1791348233"
          ]
        },
        {
          "type": "3d-nonlit-backboard",
          "name": "3D Non Lit with Backboard",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-10-3d-non-lit-with-backboard-1.png?v=1791348513",
          "desc": "Unlit 3D letters on a painted backboard, tidy corporate exterior signage with hidden hardware.",
          "gallery": []
        }
      ],
      "whys": [
        [
          "Brand-accurate colors",
          "Finishes and LED colors matched to your brand guidelines."
        ],
        [
          "Matching sign sets",
          "Facade, reception and wayfinding signs designed to look like one family."
        ],
        [
          "Free mockup on your facade",
          "See the sign on your building before you decide."
        ],
        [
          "Volume pricing",
          "Better rates when you order for several sites or several signs at once."
        ]
      ],
      "faqs": [
        [
          "What sign suits a corporate office?",
          "Corporate signage works best when it is clean and consistent. Corporate front-lit signs and 3D metal letters look professional on the facade, and corporate office signs inside the lobby can match them."
        ],
        [
          "What works best for a restaurant?",
          "Halo lit channel letters and a double sided light box give a warm glow that draws diners in. Illuminated business signs also cover entrances and patios, and a dimmer can adjust brightness for the time of day."
        ],
        [
          "Are you a commercial sign company for multi-site brands?",
          "Yes. As a commercial sign company we supply custom commercial signs and commercial signs for business chains, with the same artwork on file for every site and volume pricing on larger orders."
        ],
        [
          "Can interior and exterior signs match?",
          "Yes. We plan a corporate sign for the front and matching signs inside as a set, so fonts, colors and finishes agree. Commercial signage can be ordered in one batch."
        ],
        [
          "How quickly can we get a mockup?",
          "Send your logo and we reply within 2 hours with a free mockup on your building or wall photo."
        ]
      ],
      "cardImg": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-card.jpg?v=1791348431"
    },
    {
      "id": "metal-backlit",
      "aliases": [
        "3d-metal-backlit",
        "3d-metal-backlit-signs"
      ],
      "name": "3D Metal Backlit Signs",
      "sub": "Halo Lit Signage",
      "cardDesc": "Halo lit backlit signs for any wall, from a custom backlit sign to 3d metal signs for businesses.",
      "cover": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-letters-boutique.webp",
      "hero": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-storefront-warm.webp",
      "h1": "3D Metal Backlit Signs",
      "h1em": "Halo Lit Signage",
      "metaTitle": "3D Metal Backlit Signs | Halo Lit Signage | Signage.inc",
      "metaDesc": "Custom 3D metal backlit signs and halo lit signage for indoors and out, with backboard, raceway and hollow cut options. Free mockup in 2 hours.",
      "intro": "LEDs behind each letter wash the wall with light, so your name seems to float. This backlit signage is the most refined way to light a brand.",
      "types": [
        {
          "type": "3d-metal-backlit-letters",
          "name": "3D Metal Backlit Signs",
          "desc": "3D metal letters lit from behind, refined backlit signs and custom 3d metal signs.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-10.png?v=1791347948",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-8.png?v=1791347934",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-9.png?v=1791347941",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-11.png?v=1791347955",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-12.png?v=1791347962",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-13.png?v=1791347969",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-14.png?v=1791347975",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-15.png?v=1791347982"
          ]
        },
        {
          "type": "3d-indoor-backlit",
          "name": "Indoor 3D Backlit Signs",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-02-3d-metal-backlit-signs-2.jpg?v=1791348276",
          "desc": "A glare-free backlit sign for lobbies and offices, a halo lit sign made for indoor use.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-card.jpg?v=1791348251"
          ]
        },
        {
          "type": "metal-outdoor",
          "name": "Metal Outdoor Business Signs",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-3.png?v=1791347905",
          "desc": "Weather-hardened lighted 3d metal signs with LEDs, built as backlit signs for business.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-1.png?v=1791347891",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-2.png?v=1791347898",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-4.png?v=1791347912",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-5.png?v=1791347919",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-7.png?v=1791347926"
          ]
        },
        {
          "type": "hollow-cut",
          "name": "3D Hollow Cut Backlit Sign",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-wall-sign-hotel.webp",
          "desc": "Open-center letters that glow through and around the edge, a layered back lit 3d metal sign."
        },
        {
          "type": "3d-metal-backlit-backboard",
          "name": "3D Metal Backlit with Backboard",
          "desc": "Halo lit 3D letters on a backboard, a ready-to-hang custom backlit logo sign or custom backlit sign.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-1.jpg?v=1791348182",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-1.jpg?v=1791348182",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-2.png?v=1791348190",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-4.png?v=1791348204"
          ]
        },
        {
          "type": "3d-backlit-raceway",
          "name": "3D Backlit Sign with Raceway",
          "desc": "A 3d backlit sign pre-wired on one raceway, clean backlit signage that installs fast.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-1.png?v=1791348211",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-2.png?v=1791348219",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-3.png?v=1791348226",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-4.png?v=1791348233"
          ]
        }
      ],
      "whys": [
        [
          "Even halo glow",
          "LED spacing and standoff depth tuned so the light is smooth, not patchy."
        ],
        [
          "Dimmable on request",
          "Set the glow to match the time of day and the mood of the room."
        ],
        [
          "Premium metal finishes",
          "Brushed, painted, brass and powder-coated options in custom colors."
        ],
        [
          "Free mockup on your wall",
          "Preview the halo on a photo of your actual wall first."
        ]
      ],
      "faqs": [
        [
          "How does a 3D backlit sign work?",
          "LEDs sit behind each metal letter and wash the wall with a halo. A 3D backlit sign keeps a solid face, so it reads as a clean silhouette, and a 3D custom backlit sign can be made for any logo."
        ],
        [
          "Can I use 3D backlit signs for business outdoors?",
          "Yes. 3D backlit signs for business use weather-sealed LEDs and outdoor-rated finishes, and outdoor 3D backlit signs carry the same 2-year warranty."
        ],
        [
          "Does the wall color affect a halo lit sign?",
          "Yes. Lighter walls reflect more light, while a halo lit sign on dark brick gives a tighter, more dramatic glow. Halo lit signs are shown in your mockup so there are no surprises."
        ],
        [
          "Can a 3D back lit metal sign have hollow cut letters?",
          "Yes. A 3D back lit metal sign can be cut open so light spills through the center as well as around the rim, giving a deep, layered glow."
        ]
      ],
      "cardImg": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-2.png?v=1791347898"
    },
    {
      "id": "face-lit",
      "aliases": [
        "face-lit",
        "face-lit-signage"
      ],
      "name": "Face Lit Signage",
      "sub": "Front Lit Signs",
      "cardDesc": "Bright front lit signs, from front lit channel letters to face lit channel letters that read from far away.",
      "cover": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-bar.webp",
      "hero": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-night.webp",
      "h1": "Face Lit Signage",
      "h1em": "Front Lit Signs",
      "metaTitle": "Face Lit Signs | Front Lit Signage | Signage.inc",
      "metaDesc": "Face lit signs and front lit signage: face lit channel letters, channel letters on raceway and all lit signs for storefronts. Free mockup in 2 hours.",
      "intro": "Face lit letters put the light where people look. With front lit signage, translucent faces glow from within, so lettering stays bold and readable at night.",
      "types": [
        {
          "type": "face-lit",
          "name": "Face Lit Signs",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/image_19_df60aece-a2bf-4fdf-ba28-6d249589e765.png?v=1791533311?v=1791347856",
          "desc": "Translucent faces lit from inside, a face lit sign that suits custom led business signs.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-1.png?v=1791347843",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-2.png?v=1791347849",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-4.png?v=1791347863",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-5.png?v=1791347870",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-6.png?v=1791347877",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-7.png?v=1791347884"
          ]
        },
        {
          "type": "channel-raceway",
          "name": "Channel Letters on Raceway",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-2.jpg?v=1791348157",
          "desc": "Choose front lit channel letters or face lit channel letters on one raceway for quick installs.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-1.jpg?v=1791348151",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-2.jpg?v=1791348157",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-3.jpg?v=1791348163",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-5.png?v=1791348176"
          ]
        },
        {
          "type": "front-lit-backboard",
          "name": "Front Lit Sign with Backboard",
          "desc": "Lit letters on a painted backboard, front lit signs and led signs for business on uneven walls.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-1.jpg?v=1791348130",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-2.png?v=1791348138",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-3.png?v=1791348145"
          ]
        },
        {
          "type": "front-lit-3d",
          "name": "3D Front Lit Signage",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-2.png?v=1791347849",
          "desc": "Deep letters lit through the face, front lit signage and custom lighted signs that read at night.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-1.png?v=1791347843",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/image_19_df60aece-a2bf-4fdf-ba28-6d249589e765.png?v=1791533311?v=1791347856",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-4.png?v=1791347863",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-5.png?v=1791347870",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-6.png?v=1791347877",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-7.png?v=1791347884"
          ]
        },
        {
          "type": "front-lit-3d-backlit",
          "name": "3D Frontlit and Backlit Signs",
          "desc": "Face and halo light in one sign, lighted signs for business with real depth after dark.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-5.jpg?v=1791533507?v=1791347814",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-1.jpg?v=1791347787",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-2.jpg?v=1791347793",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-3.png?v=1791347801",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-4.jpg?v=1791347806",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-6.png?v=1791347821",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-7.png?v=1791347829",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-8.png?v=1791347836",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-card.png?v=1791347772"
          ]
        },
        {
          "type": "all-lit",
          "name": "All Lit Signs",
          "desc": "Face, edge and rear lighting in one, our brightest style of custom led signs for business.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-4.jpg?v=1791347806",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-1.jpg?v=1791347787",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-2.jpg?v=1791347793",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-3.png?v=1791347801",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-5.jpg?v=1791533507?v=1791347814",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-6.png?v=1791347821",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-7.png?v=1791347829",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-8.png?v=1791347836",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-card.png?v=1791347772"
          ]
        }
      ],
      "whys": [
        [
          "Maximum readability",
          "Bright faces with crisp edges, specified for your viewing distance."
        ],
        [
          "Choose your light color",
          "Warm white, cool white or any brand color in the LED modules."
        ],
        [
          "Clean installs",
          "Raceway and backboard options keep wiring tidy and mounting simple."
        ],
        [
          "Free mockup on your building",
          "See it lit and unlit on your own facade before you order."
        ]
      ],
      "faqs": [
        [
          "What is a face lit sign?",
          "A face lit sign has translucent letter faces lit from inside, so the whole letter glows. Face lit channel letters are the classic version, and they stay readable by day as well as at night."
        ],
        [
          "Are front lit signs different from face lit signs?",
          "They are the same style. Front lit signs and front lit signage send light forward through the face, while halo lit letters send it backward onto the wall."
        ],
        [
          "Can front lit channel letters be combined with a halo?",
          "Yes. Front lit channel letters can be paired with a 3D backlit halo, or you can choose an all lit sign for the brightest result."
        ],
        [
          "Is a face lit sign a good choice for a busy road?",
          "Yes. Because the light points toward the viewer, it is one of the easiest signs to spot from a moving car."
        ]
      ],
      "cardImg": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-1.png?v=1791347843"
    },
    {
      "id": "lightbox",
      "aliases": [
        "lightbox",
        "lightbox-signage"
      ],
      "name": "Lightbox Signage",
      "sub": "Cabinet Signs",
      "cardDesc": "A lightbox sign lights your whole logo at once, from custom light boxes to light box signs outdoor.",
      "cover": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-square-projecting-light-box.webp",
      "hero": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-light-box-bar-entrance.webp",
      "h1": "Lightbox Signage",
      "h1em": "Cabinet Signs",
      "metaTitle": "Lightbox Signs | Custom Light Box Signs | Signage.inc",
      "metaDesc": "Custom lightbox signs for business: wall mounted, double sided and 3D lightbox signage in any shape or size. Free mockup in 2 hours.",
      "intro": "A lightbox gives maximum brightness at a sensible price. Mount lightbox signs flat on the wall or project them out for sidewalk traffic.",
      "types": [
        {
          "type": "light-box-single",
          "name": "Wall Mounted Light Box",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-9.jpg?v=1791348037",
          "desc": "An evenly lit wall cabinet, a classic lightbox sign and one of our light box signs for business.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-1.jpg?v=1791347988",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-2.jpg?v=1791347994",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-3.jpg?v=1791348000",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-4.jpg?v=1791348005",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-5.jpg?v=1791348012",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-6.jpg?v=1791348018",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-7.jpg?v=1791348024",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-8.jpg?v=1791348030",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-10.jpg?v=1791348043",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-11.jpg?v=1791348049",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-12.png?v=1791348057"
          ]
        },
        {
          "type": "light-box-double",
          "name": "Double Sided Light Box Sign",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-outdoor-signs-04-double-sided-light-box-3.jpg?v=1791348419",
          "desc": "A two-way business light box sign, one of our lightbox signs made for busy corners.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-outdoor-signs-04-double-sided-light-box-2.jpg?v=1791348413",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-outdoor-signs-04-double-sided-light-box-1.jpg?v=1791348408",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-outdoor-signs-04-double-sided-light-box-4.jpg?v=1791348425"
          ]
        },
        {
          "type": "custom-lightbox",
          "name": "Custom Lightbox Signage",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-4.jpg?v=1791348005",
          "desc": "Lit boxes in any shape or size, a custom lightbox sign or custom light box sign for your logo.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-1.jpg?v=1791347988",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-2.jpg?v=1791347994",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-3.jpg?v=1791348000",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-10.jpg?v=1791348043",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-5.jpg?v=1791348012",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-6.jpg?v=1791348018",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-7.jpg?v=1791348024",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-8.jpg?v=1791348030",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-9.jpg?v=1791348037",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-11.jpg?v=1791348049",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-12.png?v=1791348057"
          ]
        },
        {
          "type": "3d-lightbox",
          "name": "3D Lightbox Signage",
          "desc": "Raised faces add depth to light box signs, custom light boxes that stand out as illuminated signs.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-11.jpg?v=1791348049",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-1.jpg?v=1791347988",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-2.jpg?v=1791347994",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-3.jpg?v=1791348000",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-4.jpg?v=1791348005",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-6.jpg?v=1791348018",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-7.jpg?v=1791348024",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-8.jpg?v=1791348030",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-9.jpg?v=1791348037",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-10.jpg?v=1791348043",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-5.jpg?v=1791348012",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-12.png?v=1791348057"
          ]
        }
      ],
      "whys": [
        [
          "Great value brightness",
          "One of the most cost-effective ways to light a full logo."
        ],
        [
          "Any shape you need",
          "Square, round, vertical or fully custom outlines."
        ],
        [
          "Easy to update",
          "Swap the face later if your logo or offer changes."
        ],
        [
          "Free mockup on your building",
          "Check size and position on your own facade first."
        ]
      ],
      "faqs": [
        [
          "What is a lightbox sign?",
          "A lightbox sign is an illuminated cabinet lit from inside so the whole logo glows. Lightbox signs are bright, simple and cost-effective, and a custom lightbox sign can be made in any shape."
        ],
        [
          "Should I choose a wall mounted or double sided light box?",
          "A wall mounted light box sits flat on the wall, while a double sided light box projects so people can see it from both directions. Either works as a business light box sign on a busy street."
        ],
        [
          "Can you make custom light boxes?",
          "Yes. Custom light boxes can be round, tall and narrow or fully custom, and a custom light box sign can carry your full-color logo. Light box signs for business can also have raised 3D faces."
        ],
        [
          "Can light box signs outdoor handle bad weather?",
          "Yes. Light box signs outdoor use sealed cabinets and commercial-grade LEDs."
        ],
        [
          "How long do the LEDs last?",
          "Commercial-grade LEDs are rated for tens of thousands of hours. Our custom led signs for business and custom led business signs carry a 2-year warranty on every component."
        ]
      ],
      "cardImg": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-5.jpg?v=1791348012&width=640"
    },
    {
      "id": "channel-letters",
      "aliases": [
        "channel-raceway",
        "illuminated-channel-letters"
      ],
      "name": "Illuminated Channel Letters",
      "sub": "Raceway Signage",
      "cardDesc": "Lit channel letters on a tidy raceway, from custom channel letters and aluminium letters signs to custom illuminated channel letters.",
      "cover": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-channel-letters-coffee.webp",
      "hero": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-letters-hair-studio.webp",
      "h1": "Illuminated Channel Letters",
      "h1em": "Raceway Signage",
      "metaTitle": "Illuminated Channel Letters | Raceway Signs | Signage.inc",
      "metaDesc": "Custom channel letters signage on raceway or backboard: illuminated channel letters, halo lit and 3D channel letters. Free mockup in 2 hours.",
      "intro": "Our channel letters are hollow letters with LEDs inside, the backbone of commercial signage. A raceway keeps wiring neat, and 3d illuminated channel letters add real depth.",
      "types": [
        {
          "type": "illuminated-channel",
          "name": "Illuminated Channel Letters",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-4.jpg?v=1791347806",
          "desc": "LED-filled hollow letters, illuminated channel letters and custom illuminated signs in any font.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-1.jpg?v=1791347787",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-2.jpg?v=1791347793",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-3.png?v=1791347801",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-5.jpg?v=1791533507?v=1791347814",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-6.png?v=1791347821",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-7.png?v=1791347829",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-8.png?v=1791347836",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-card.png?v=1791347772"
          ]
        },
        {
          "type": "channel-backboard",
          "name": "Channel Letters on Backboard",
          "desc": "Lit letters on a painted backboard, a channel letters sign and illuminated sign for brick or stucco.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-2.png?v=1791348138",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-1.jpg?v=1791348130",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-3.png?v=1791348145"
          ]
        },
        {
          "type": "channel-raceway",
          "name": "Channel Letters on Raceway",
          "desc": "Letters wired onto one raceway bar, channel letters signage that installs fast with hidden wiring.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-2.jpg?v=1791348157",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-1.jpg?v=1791348151",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-2.jpg?v=1791348157",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-3.jpg?v=1791348163",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-5.png?v=1791348176"
          ]
        },
        {
          "type": "halo-lit-channel",
          "name": "Halo Lit Channel Letters",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-11.png?v=1791347955",
          "desc": "Letters that throw light onto the wall, custom channel letters with a soft, glare-free halo.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-8.png?v=1791347934",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-9.png?v=1791347941",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-10.png?v=1791347948",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-12.png?v=1791347962",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-13.png?v=1791347969",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-14.png?v=1791347975",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-15.png?v=1791347982"
          ]
        },
        {
          "type": "3d-channel-letters",
          "name": "3D Channel Letters",
          "desc": "An aluminum letters sign with deep returns, 3d illuminated letters for bold channel letters.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-10.png?v=1791347948",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-8.png?v=1791347934",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-9.png?v=1791347941",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-11.png?v=1791347955",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-12.png?v=1791347962",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-13.png?v=1791347969",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-14.png?v=1791347975",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-15.png?v=1791347982"
          ]
        },
        {
          "type": "storefront-lighted",
          "name": "Storefront Lighted Signs",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-8.png?v=1791347836",
          "desc": "Open-face letters with exposed LEDs, retro lighted signs and lighted outdoor signs for business.",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-1.jpg?v=1791347787",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-2.jpg?v=1791347793",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-3.png?v=1791347801",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-4.jpg?v=1791347806",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-5.jpg?v=1791533507?v=1791347814",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-6.png?v=1791347821",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-7.png?v=1791347829",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-card.png?v=1791347772"
          ]
        },
        {
          "type": "metal-letters-backboard",
          "name": "Metal Letters with Backboard",
          "desc": "Lit aluminium letters signs on a backer with hidden wiring, an illuminated channel letter sign.",
          "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-1.jpg?v=1791348182",
          "gallery": [
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-2.png?v=1791348190",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-3.png?v=1791348196",
            "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-4.png?v=1791348204"
          ]
        }
      ],
      "whys": [
        [
          "Installation made simple",
          "Raceway mounting means one rail to fix and one connection to make."
        ],
        [
          "Hidden wiring",
          "Drivers and cables are enclosed, so the finished sign looks clean."
        ],
        [
          "Any font, any color",
          "Your exact lettering, fabricated and finished to match your brand."
        ],
        [
          "Free mockup on your building",
          "See the letters on a photo of your facade before production."
        ]
      ],
      "faqs": [
        [
          "What are channel letters?",
          "Channel letters are hollow, fabricated letters with LEDs inside. A channel letters sign is the standard choice for shop fronts, and we supply custom channel letters in any font, size and color."
        ],
        [
          "What does a raceway do?",
          "A raceway is a slim metal bar fixed to the wall that holds the wiring and power supplies. Channel letters signage on a raceway installs quickly, with no cables run through your wall."
        ],
        [
          "Should illuminated channel letters be face lit or halo lit?",
          "Either, or both. Illuminated channel letters can shine forward through the face, backward onto the wall, or in both directions, and your mockup shows each option."
        ],
        [
          "Can channel letters go on a backboard?",
          "Yes. Channel letters on a backboard suit uneven walls, and metal letters with a backboard give an illuminated channel letter sign a tidy finish."
        ],
        [
          "How big can channel letters be?",
          "From a few inches tall up to several feet. Tell us the wall size and viewing distance and we will recommend letter heights."
        ]
      ],
      "cardImg": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-5.png?v=1791348176"
    }
  ],
  types: {
    "3d-acrylic-lit-letters": {
      "name": "3D Acrylic Front Lit, 3D Backlit & Side Lit",
      "short": "3D Acrylic Lit Letters",
      "desc": "Dimensional letters with glowing faces, lit edges or a soft halo. Crisp by day, bold after dark.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-front-lit-pizzeria.webp",
      "tags": [
        "Lit",
        "3D Acrylic",
        "Indoor / Outdoor"
      ],
      "mockup": "Face Lit"
    },
    "3d-acrylic-lit-backboard": {
      "name": "3D Acrylic Backlit with Backboard/Raceway",
      "short": "3D Acrylic Lit on Backboard",
      "desc": "Lit letters set on a backboard or raceway, giving uneven walls a clean, framed illuminated look.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-letters-hair-studio.webp",
      "tags": [
        "Lit",
        "3D Acrylic",
        "Backboard / Raceway"
      ],
      "mockup": "Face Lit"
    },
    "3d-acrylic-double-lit": {
      "name": "3D Acrylic Double Lit",
      "short": "3D Acrylic Double Lit",
      "desc": "Letters that glow from the face and cast a halo at the same time for maximum depth and impact.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-side-lit-letters-blue.webp",
      "tags": [
        "Lit",
        "3D Acrylic",
        "Outdoor"
      ],
      "mockup": "Face Lit"
    },
    "3d-acrylic-nonlit": {
      "name": "3D Acrylic Non-Lit Letters",
      "short": "3D Acrylic Non-Lit Letters",
      "desc": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-layered-letters-interior.webp",
      "tags": [
        "Non-Lit",
        "3D Acrylic",
        "Indoor"
      ],
      "mockup": "Flat Cut"
    },
    "3d-metal-backlit-letters": {
      "name": "3D Metal Backlit Letters",
      "short": "3D Metal Backlit Letters",
      "desc": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-letters-boutique.webp",
      "tags": [
        "Lit",
        "3D Metal",
        "Indoor / Outdoor"
      ],
      "mockup": "Halo Lit"
    },
    "3d-metal-backlit-backboard": {
      "name": "3D Metal Backlit with Backboard/Raceway",
      "short": "3D Metal Backlit on Backboard",
      "desc": "3D metal backlit letters mounted on a backboard or raceway for clean, streamlined installation.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-backboard-beauty.webp",
      "tags": [
        "Lit",
        "3D Metal",
        "Backboard / Raceway"
      ],
      "mockup": "Halo Lit"
    },
    "3d-metal-nonlit": {
      "name": "3D Metal Non Lit",
      "short": "3D Metal Non-Lit Letters",
      "desc": "Brushed, polished or painted metal letters with real depth. No wiring, no maintenance.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-letters-gym-wall.webp",
      "tags": [
        "Non-Lit",
        "3D Metal",
        "Indoor / Outdoor"
      ],
      "mockup": "Fabricated"
    },
    "3d-nonlit-backboard": {
      "name": "3D Non Lit with Backboard",
      "short": "3D Non-Lit on Backboard",
      "desc": "Dimensional letters on a custom backboard in metal, wood or painted finishes. Easy to install anywhere.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-letters-backboard-beauty.webp",
      "tags": [
        "Non-Lit",
        "Backboard",
        "Indoor / Outdoor"
      ],
      "mockup": "Fabricated"
    },
    "metal-2d": {
      "name": "2D Metal Sign",
      "short": "2D Metal Sign",
      "desc": "Laser-cut logos and lettering in slim 2mm or 5mm metal. Precise, flat and built to last.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-flat-cut-metal-sign.webp",
      "tags": [
        "Non-Lit",
        "Metal",
        "Indoor / Outdoor"
      ],
      "mockup": "Flat Cut"
    },
    "stainless-steel": {
      "name": "Custom Stainless Steel Signs",
      "short": "Stainless Steel Signs",
      "desc": "Brushed stainless: custom indoor signs for business.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-reception-law-wall-sign.webp",
      "tags": [
        "Non-Lit",
        "Stainless Steel",
        "Indoor"
      ],
      "mockup": "Flat Cut"
    },
    "metal-letters-backboard": {
      "name": "Metal Letters with Backboard",
      "short": "Metal Letters with Backboard",
      "desc": "Fabricated letters fixed to a mounting backer with all wiring tucked out of sight, ready to hang.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-logo-backboard.webp",
      "tags": [
        "Lit",
        "Metal",
        "Backboard / Raceway"
      ],
      "mockup": "Halo Lit"
    },
    "metal-outdoor": {
      "name": "Metal Outdoor Business Signs",
      "short": "Metal Outdoor Signs",
      "desc": "Brushed or painted metal lettering with rear LEDs, built to shrug off rain, sun and snow.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-letters-exterior-wall.webp",
      "tags": [
        "Lit",
        "3D Metal",
        "Outdoor"
      ],
      "mockup": "Halo Lit"
    },
    "hollow-cut": {
      "name": "3D Hollow Cut Backlit Sign",
      "short": "3D Hollow Cut Backlit",
      "desc": "Letters cut open so light spills around the rim and through the center for striking depth.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-letters-textured-wall.webp",
      "tags": [
        "Lit",
        "3D Metal",
        "Indoor / Outdoor"
      ],
      "mockup": "Halo Lit"
    },
    "3d-indoor-backlit": {
      "name": "Indoor 3D Backlit Signs",
      "short": "Indoor 3D Backlit Signs",
      "desc": "A soft wall-wash glow for business signs indoor and lobbies.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-logo-lobby.webp",
      "tags": [
        "Lit",
        "3D",
        "Indoor"
      ],
      "mockup": "Halo Lit"
    },
    "3d-backlit-raceway": {
      "name": "3D Backlit Sign with Raceway",
      "short": "3D Backlit with Raceway",
      "desc": "3D backlit letters pre-mounted on a raceway bar with every wire and driver contained.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-backboard-beauty.webp",
      "tags": [
        "Lit",
        "3D",
        "Raceway"
      ],
      "mockup": "Halo Lit"
    },
    "halo-lit-channel": {
      "name": "Halo Lit Channel Letters",
      "short": "Halo Lit Channel Letters",
      "desc": "Fabricated letters that wash the wall behind them with a soft ring of light.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-storefront-warm.webp",
      "tags": [
        "Lit",
        "Channel Letters",
        "Outdoor"
      ],
      "mockup": "Halo Lit"
    },
    "face-lit": {
      "name": "Face Lit Signs",
      "short": "Face Lit Signs",
      "desc": "Translucent faces lit from within, giving bright, even lettering that is easy to read at night.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-bar.webp",
      "tags": [
        "Lit",
        "Face Lit",
        "Outdoor"
      ],
      "mockup": "Face Lit"
    },
    "front-lit-backboard": {
      "name": "Front Lit with Backboard",
      "short": "Front Lit with Backboard",
      "desc": "Lit letters set on a painted backer so uneven walls still get a tidy, finished result.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-restaurant-facade-flame-logo.webp",
      "tags": [
        "Lit",
        "Backboard",
        "Outdoor"
      ],
      "mockup": "Face Lit"
    },
    "front-lit-3d": {
      "name": "3D Front Lit Signage",
      "short": "3D Front Lit Signage",
      "desc": "Deep dimensional letters with lit faces that stay legible from across the street.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-front-lit-steakhouse.webp",
      "tags": [
        "Lit",
        "3D",
        "Outdoor"
      ],
      "mockup": "Face Lit"
    },
    "front-lit-3d-backlit": {
      "name": "3D Frontlit and Backlit Signs",
      "short": "3D Frontlit + Backlit",
      "desc": "Lit faces plus a 3D backlit halo behind the letters, so your name glows in two layers.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-lit-logo-pizzeria.webp",
      "tags": [
        "Lit",
        "3D",
        "Outdoor"
      ],
      "mockup": "Halo Lit"
    },
    "all-lit": {
      "name": "All Lit Sign",
      "short": "All Lit Sign",
      "desc": "Faces, edges and a rear halo all glowing together for the brightest possible letter sign.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-blue-night.webp",
      "tags": [
        "Lit",
        "3D",
        "Outdoor"
      ],
      "mockup": "Face Lit"
    },
    "corporate-front-lit": {
      "name": "Corporate Front-Lit Signs",
      "short": "Corporate Front-Lit",
      "desc": "Clean, evenly lit lettering for office towers, business parks and corporate frontages.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-night.webp",
      "tags": [
        "Lit",
        "Face Lit",
        "Outdoor"
      ],
      "mockup": "Face Lit"
    },
    "illuminated-channel": {
      "name": "Illuminated Channel Letters",
      "short": "Illuminated Channel Letters",
      "desc": "Hand-fabricated letters with internal LEDs, the dependable choice for storefronts and facades.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-channel-letters-coffee.webp",
      "tags": [
        "Lit",
        "Channel Letters",
        "Outdoor"
      ],
      "mockup": "Face Lit"
    },
    "channel-raceway": {
      "name": "Channel Letters on Raceway",
      "short": "Channel Letters on Raceway",
      "desc": "Letters pre-wired onto one raceway bar, so installation is quick and the wiring stays hidden.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-gold-letters.webp",
      "tags": [
        "Lit",
        "Raceway",
        "Outdoor"
      ],
      "mockup": "Face Lit"
    },
    "3d-channel-letters": {
      "name": "3D Channel Letters",
      "short": "3D Channel Letters",
      "desc": "Deep aluminum returns and LED modules create boldly dimensional lettering with strong shadow lines.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-lit-letters-distillery.webp",
      "tags": [
        "Lit",
        "3D Metal",
        "Outdoor"
      ],
      "mockup": "Face Lit"
    },
    "storefront-lighted": {
      "name": "Storefront Lighted Signs",
      "short": "Storefront Lighted Signs",
      "desc": "Open-face letters with visible LED tubing give your facade a bold, retro-modern character.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-neon-sign-restaurant-script.webp",
      "tags": [
        "Lit",
        "Open Face",
        "Outdoor"
      ],
      "mockup": "Face Lit"
    },
    "fabricated-sign": {
      "name": "Fabricated Sign",
      "short": "Fabricated Sign",
      "desc": "Welded metal letters with returns, faces and built-in LED modules, made from scratch to your drawings.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-polished-gold-3d-letters.webp",
      "tags": [
        "Lit",
        "Fabricated",
        "Outdoor"
      ],
      "mockup": "Fabricated"
    },
    "push-thru": {
      "name": "Push Thru",
      "short": "Push-Thru Sign",
      "desc": "Illuminated cabinet with letters and logos pushed through the face. Sharp contrast, strong presence.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-push-thru-shaped-sign.webp",
      "tags": [
        "Lit",
        "Light Box",
        "Indoor / Outdoor"
      ],
      "mockup": "Push Through"
    },
    "light-box-single": {
      "name": "Wall Mounted Lightbox",
      "short": "Wall-Mounted Light Box",
      "desc": "A wall-mounted illuminated cabinet that lights your entire logo evenly. Simple, bright and cost-effective.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-single-sided-light-box-salon.webp",
      "tags": [
        "Lit",
        "Light Box",
        "Wall Mounted"
      ],
      "mockup": "Lightbox"
    },
    "light-box-double": {
      "name": "Double Sided Lightbox",
      "short": "Double-Sided Light Box",
      "desc": "Projects from the wall so pedestrians can see it from both directions. Square, round or custom shapes.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-square-projecting-light-box.webp",
      "tags": [
        "Lit",
        "Light Box",
        "Projecting"
      ],
      "mockup": "Lightbox"
    },
    "cabinet-sign": {
      "name": "Illuminated Cabinet Sign",
      "short": "Illuminated Cabinet Sign",
      "desc": "A classic lit cabinet that keeps roadside and strip-mall businesses easy to spot.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-light-box-bar-entrance.webp",
      "tags": [
        "Lit",
        "Cabinet",
        "Outdoor"
      ],
      "mockup": "Lightbox"
    },
    "custom-lightbox": {
      "name": "Custom Lightbox Signage",
      "short": "Custom Lightbox",
      "desc": "Any shape, size and face artwork built into an illuminated box made to your specification.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-projecting-light-box-square-cafe.webp",
      "tags": [
        "Lit",
        "Light Box",
        "Custom"
      ],
      "mockup": "Lightbox"
    },
    "3d-lightbox": {
      "name": "3D Lightbox Signage",
      "short": "3D Lightbox",
      "desc": "Raised faces on a lit box add dimension and shadow to an otherwise flat cabinet sign.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-projecting-light-box-vertical.webp",
      "tags": [
        "Lit",
        "Light Box",
        "3D"
      ],
      "mockup": "Lightbox"
    },
    "hanging-light-box": {
      "name": "Illuminated Hanging Sign",
      "short": "Illuminated Hanging Sign",
      "desc": "A hanging lit sign for business signs indoor.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-order-here-hanging-sign.webp",
      "tags": [
        "Lit",
        "Hanging",
        "Indoor"
      ],
      "mockup": "Lightbox"
    },
    "commercial-light-up": {
      "name": "Commercial Light Up Signs",
      "short": "Commercial Light-Up",
      "desc": "High-output LED signs sized for retail strips, plazas and busy commercial corners.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-industrial-light-box-sign.webp",
      "tags": [
        "Lit",
        "Commercial",
        "Outdoor"
      ],
      "mockup": "Lightbox"
    },
    "3d-acrylic-lit-raceway": {
      "name": "3D Acrylic Front Lit with Raceway",
      "short": "3D Acrylic Lit on Raceway",
      "desc": "3D acrylic front lit letters wired onto one raceway bar, so installation is quick and the wiring stays hidden.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-gold-letters.webp",
      "tags": [
        "Lit",
        "3D Acrylic",
        "Raceway"
      ],
      "mockup": "Face Lit"
    },
    "channel-backboard": {
      "name": "Channel Letters on Backboard",
      "short": "Channel Letters on Backboard",
      "desc": "Illuminated channel letters fixed to a painted backboard, giving uneven walls a clean, finished look.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-letters-hair-studio.webp",
      "tags": [
        "Lit",
        "Channel Letters",
        "Backboard"
      ],
      "mockup": "Face Lit"
    },
    "corporate-signage": {
      "name": "Corporate Signage",
      "short": "Corporate Signage",
      "desc": "Polished, brand-accurate signs for head offices, business parks and corporate lobbies.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-letters-cafe.webp",
      "tags": [
        "Lit",
        "Corporate",
        "Indoor / Outdoor"
      ],
      "mockup": "Face Lit"
    },
    "commercial-signage": {
      "name": "Commercial Signage",
      "short": "Commercial Signage",
      "desc": "Custom-built signs for retail strips, restaurants, plazas and larger commercial frontages.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-real-estate-office-fascia.webp",
      "tags": [
        "Lit",
        "Commercial",
        "Outdoor"
      ],
      "mockup": "Face Lit"
    },
    "laser-cut": {
      "name": "Laser Cut Signs",
      "short": "Laser Cut Signs",
      "desc": "Precise cut shapes for business signs indoor.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-layered-letters-interior.webp",
      "tags": [
        "Non-Lit",
        "Laser Cut",
        "Indoor"
      ],
      "mockup": "Flat Cut"
    },
    "exterior-lighted": {
      "name": "Exterior Lighted Signs",
      "short": "Exterior Lighted Signs",
      "desc": "Weather-sealed LED signs that keep your business visible long after the sun goes down.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-blue-night.webp",
      "tags": [
        "Lit",
        "Weather Sealed",
        "Outdoor"
      ],
      "mockup": "Face Lit"
    },
    "commercial-exterior": {
      "name": "Commercial Exterior Signs",
      "short": "Commercial Exterior Signs",
      "desc": "Custom-built signs for multi-site brands, plazas and larger commercial frontages.",
      "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-real-estate-office-fascia.webp",
      "tags": [
        "Lit",
        "Commercial",
        "Outdoor"
      ],
      "mockup": "Fabricated"
    }
  },
  gallery: {
    "3d-acrylic-lit-letters": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-front-lit-pizzeria.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-lit-logo-pizzeria.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-front-lit-steakhouse.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-bar.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-side-lit-letters-blue.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-night.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-blue-night.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-auto-detailing-garage-sign.webp"
    ],
    "3d-acrylic-lit-backboard": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-letters-hair-studio.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-restaurant-facade-flame-logo.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-lit-logo-pizzeria.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-gold-letters.webp"
    ],
    "3d-acrylic-double-lit": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-side-lit-letters-blue.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-blue-night.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-lit-logo-pizzeria.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-auto-detailing-garage-sign.webp"
    ],
    "3d-acrylic-nonlit": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-layered-letters-interior.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-non-lit-letters-nail-salon.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-reception-lobby-logo.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-dental-reception-logo.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-medical-reception-logo.webp"
    ],
    "3d-metal-backlit-letters": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-letters-boutique.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-letters-cafe.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-garden-wall.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-storefront-warm.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-spa.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-letters-textured-wall.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-wall-sign-hotel.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-logo-lobby.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-lit-letters-distillery.webp"
    ],
    "3d-metal-backlit-backboard": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-backboard-beauty.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-logo-backboard.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-reception-logo-wall-boutique.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-panel-restaurant.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-panel-gastro-pub.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-brass-plaque-halo-lit.webp"
    ],
    "3d-metal-nonlit": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-letters-gym-wall.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-letters-exterior-wall.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-letters-interior-wall.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-salon-wall-letters.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-reception-law-wall-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-real-estate-office-fascia.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-polished-gold-3d-letters.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-office-logo-wall-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-vertical-3d-metal-letters-interior.webp"
    ],
    "3d-nonlit-backboard": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-letters-backboard-beauty.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-letters-corrugated-wall.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-non-lit-letters-dental-building.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-office-logo-wall-sign.webp"
    ],
    "metal-2d": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-flat-cut-metal-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-salon-fascia-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-projecting-sign-graphic-studio.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-medical-reception-logo.webp"
    ],
    "stainless-steel": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-reception-law-wall-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-office-logo-wall-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-polished-gold-3d-letters.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-vertical-3d-metal-letters-interior.webp"
    ],
    "metal-letters-backboard": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-logo-backboard.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-panel-restaurant.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-panel-gastro-pub.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-letters-backboard-beauty.webp"
    ],
    "metal-outdoor": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-letters-exterior-wall.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-garden-wall.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-storefront-warm.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-real-estate-office-fascia.webp"
    ],
    "hollow-cut": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-letters-textured-wall.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-wall-sign-hotel.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-brass-plaque-halo-lit.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-spa.webp"
    ],
    "3d-indoor-backlit": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-logo-lobby.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-spa.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-reception-logo-wall-boutique.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-wall-sign-hotel.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-brass-plaque-halo-lit.webp"
    ],
    "3d-backlit-raceway": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-backboard-beauty.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-logo-backboard.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-panel-restaurant.webp"
    ],
    "halo-lit-channel": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-storefront-warm.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-garden-wall.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-spa.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-round-halo-lit-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-letters-cafe.webp"
    ],
    "face-lit": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-bar.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-night.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-gold-letters.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-channel-letters-coffee.webp"
    ],
    "front-lit-backboard": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-restaurant-facade-flame-logo.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-letters-hair-studio.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-gold-letters.webp"
    ],
    "front-lit-3d": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-front-lit-steakhouse.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-front-lit-pizzeria.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-blue-night.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-night.webp"
    ],
    "front-lit-3d-backlit": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-lit-logo-pizzeria.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-side-lit-letters-blue.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-front-lit-pizzeria.webp"
    ],
    "all-lit": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-blue-night.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-side-lit-letters-blue.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-lit-logo-pizzeria.webp"
    ],
    "corporate-front-lit": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-night.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-channel-letters-coffee.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-gold-letters.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-bar.webp"
    ],
    "illuminated-channel": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-channel-letters-coffee.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-letters-hair-studio.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-gold-letters.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-night.webp"
    ],
    "channel-raceway": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-gold-letters.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-letters-hair-studio.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-channel-letters-coffee.webp"
    ],
    "3d-channel-letters": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-lit-letters-distillery.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-letters-cafe.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-front-lit-steakhouse.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-blue-night.webp"
    ],
    "storefront-lighted": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-neon-sign-restaurant-script.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-neon-sign-cinema.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-restaurant-facade-flame-logo.webp"
    ],
    "fabricated-sign": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-polished-gold-3d-letters.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-restaurant-facade-flame-logo.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-gold-letters.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-real-estate-office-fascia.webp"
    ],
    "push-thru": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-push-thru-shaped-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-single-sided-light-box-storefront.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-light-box-bar-entrance.webp"
    ],
    "light-box-single": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-single-sided-light-box-salon.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-single-sided-light-box-storefront.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-industrial-light-box-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-light-box-bar-entrance.webp"
    ],
    "light-box-double": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-square-projecting-light-box.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-round-projecting-light-box.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-round-projecting-light-box-cafe.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-round-projecting-light-box-coffee.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-projecting-light-box-vertical.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-projecting-light-box-square-cafe.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-order-here-hanging-sign.webp"
    ],
    "cabinet-sign": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-light-box-bar-entrance.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-industrial-light-box-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-single-sided-light-box-storefront.webp"
    ],
    "custom-lightbox": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-projecting-light-box-square-cafe.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-round-projecting-light-box-cafe.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-push-thru-shaped-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-round-projecting-light-box.webp"
    ],
    "3d-lightbox": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-projecting-light-box-vertical.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-square-projecting-light-box.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-projecting-light-box-square-cafe.webp"
    ],
    "hanging-light-box": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-order-here-hanging-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-projecting-light-box-vertical.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-projecting-sign-graphic-studio.webp"
    ],
    "commercial-light-up": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-industrial-light-box-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-light-box-bar-entrance.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-single-sided-light-box-storefront.webp"
    ],
    "laser-cut": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-layered-letters-interior.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-flat-cut-metal-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-reception-lobby-logo.webp"
    ],
    "exterior-lighted": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-blue-night.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-night.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-storefront-warm.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-auto-detailing-garage-sign.webp"
    ],
    "commercial-exterior": [
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-real-estate-office-fascia.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-auto-detailing-garage-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-industrial-light-box-sign.webp",
      "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-letters-exterior-wall.webp"
    ]
  },
  images: {
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-5.jpg?v=1791348012&width=640": [640, 543],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/Rebel_Wear_Neon_Storefront_Sign.jpg?v=1791284725": [1000, 1000],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-front-lit-pizzeria.webp": [1200, 800],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-front-lit-steakhouse.webp": [736, 736],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-layered-letters-interior.webp": [1200, 1064],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-acrylic-lit-logo-pizzeria.webp": [1200, 909],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-bar.webp": [736, 736],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-blue-night.webp": [736, 920],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-front-lit-letters-night.webp": [736, 598],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-letters-backboard-beauty.webp": [1200, 759],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-letters-corrugated-wall.webp": [640, 480],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-backboard-beauty.webp": [1200, 909],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-letters-boutique.webp": [736, 674],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-letters-cafe.webp": [736, 981],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-letters-textured-wall.webp": [736, 981],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-logo-backboard.webp": [1199, 1312],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-panel-gastro-pub.webp": [736, 552],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-backlit-panel-restaurant.webp": [375, 667],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-letters-exterior-wall.webp": [736, 736],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-letters-gym-wall.webp": [640, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-letters-interior-wall.webp": [736, 1308],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-metal-lit-letters-distillery.webp": [736, 981],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-non-lit-letters-dental-building.webp": [635, 479],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-non-lit-letters-nail-salon.webp": [736, 736],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-side-lit-letters-blue.webp": [736, 736],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-auto-detailing-garage-sign.webp": [640, 537],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-brass-plaque-halo-lit.webp": [736, 980],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-dental-reception-logo.webp": [640, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-flat-cut-metal-sign.webp": [1080, 1080],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-channel-letters-coffee.webp": [1200, 1088],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-gold-letters.webp": [640, 427],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-front-lit-letters-hair-studio.webp": [1200, 1088],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-garden-wall.webp": [640, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-spa.webp": [640, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-letters-storefront-warm.webp": [640, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-logo-lobby.webp": [640, 432],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-halo-lit-wall-sign-hotel.webp": [736, 920],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-industrial-light-box-sign.webp": [640, 639],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-light-box-bar-entrance.webp": [640, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-medical-reception-logo.webp": [640, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-neon-sign-cinema.webp": [640, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-neon-sign-restaurant-script.webp": [640, 447],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-office-logo-wall-sign.webp": [736, 920],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-order-here-hanging-sign.webp": [640, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-polished-gold-3d-letters.webp": [735, 490],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-projecting-light-box-square-cafe.webp": [427, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-projecting-light-box-vertical.webp": [1200, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-projecting-sign-graphic-studio.webp": [640, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-push-thru-shaped-sign.webp": [1200, 909],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-real-estate-office-fascia.webp": [640, 427],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-reception-law-wall-sign.webp": [640, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-reception-lobby-logo.webp": [640, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-reception-logo-wall-boutique.webp": [736, 736],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-restaurant-facade-flame-logo.webp": [1200, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-round-halo-lit-sign.webp": [550, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-round-projecting-light-box.webp": [1200, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-round-projecting-light-box-cafe.webp": [1200, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-round-projecting-light-box-coffee.webp": [640, 640],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-salon-fascia-sign.webp": [640, 278],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-salon-wall-letters.webp": [600, 600],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-single-sided-light-box-salon.webp": [1200, 900],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-single-sided-light-box-storefront.webp": [736, 551],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-square-projecting-light-box.webp": [736, 736],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-vertical-3d-metal-letters-interior.webp": [736, 1308],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-card.png?v=1791347772": [1254, 1254],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-6.png?v=1791347821": [1310, 1201],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-1.jpg?v=1791347787": [736, 552],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-2.jpg?v=1791347793": [667, 1000],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-3.png?v=1791347801": [1121, 1403],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-4.jpg?v=1791347806": [800, 800],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-5.jpg?v=1791533507?v=1791347814": [1254, 1254],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-7.png?v=1791347829": [1536, 1024],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-01-3d-acrylic-doublelit-signs-8.png?v=1791347836": [1493, 1053],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-1.png?v=1791347843": [1200, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-2.png?v=1791347849": [735, 919],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/image_19_df60aece-a2bf-4fdf-ba28-6d249589e765.png?v=1791533311?v=1791347856": [1000, 1500],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-4.png?v=1791347863": [1200, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-5.png?v=1791347870": [800, 1196],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-6.png?v=1791347877": [1200, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-02-3d-acrylic-frontlit-signs-7.png?v=1791347884": [1200, 960],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-1.png?v=1791347891": [622, 619],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-2.png?v=1791347898": [736, 736],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-3.png?v=1791347905": [736, 759],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-4.png?v=1791347912": [736, 736],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-5.png?v=1791347919": [1000, 1500],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-7.png?v=1791347926": [1080, 1080],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-8.png?v=1791347934": [800, 800],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-9.png?v=1791347941": [1199, 1505],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-10.png?v=1791347948": [1140, 1140],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-11.png?v=1791347955": [1199, 1330],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-12.png?v=1791347962": [800, 800],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-13.png?v=1791347969": [1200, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-14.png?v=1791347975": [564, 752],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-03-3d-metal-backlit-signs-15.png?v=1791347982": [900, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-4.jpg?v=1791348005": [640, 800],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-1.jpg?v=1791347988": [736, 980],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-2.jpg?v=1791347994": [1200, 1600],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-3.jpg?v=1791348000": [1100, 688],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-5.jpg?v=1791348012": [882, 749],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-6.jpg?v=1791348018": [800, 534],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-7.jpg?v=1791348024": [972, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-8.jpg?v=1791348030": [800, 800],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-9.jpg?v=1791348037": [1100, 733],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-10.jpg?v=1791348043": [1080, 1440],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-11.jpg?v=1791348049": [1200, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-04-single-sided-lightbox-signs-12.png?v=1791348057": [1302, 1208],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-05-push-through-signs-2.png?v=1791348070": [1000, 1000],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-05-push-through-signs-1.png?v=1791348063": [1000, 1000],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-06-3d-metal-non-lit-signs-3.jpg?v=1791348087": [736, 920],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-06-3d-metal-non-lit-signs-1.jpg?v=1791348075": [736, 488],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-06-3d-metal-non-lit-signs-2.jpg?v=1791348082": [843, 1264],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-06-3d-metal-non-lit-signs-4.png?v=1791348094": [618, 613],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-07-2d-metal-non-lit-signs-2.jpg?v=1791348100": [600, 600],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-07-2d-metal-non-lit-signs-3.jpg?v=1791348106": [736, 1308],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-07-2d-metal-non-lit-signs-4.jpg?v=1791348112": [1170, 1500],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-07-2d-metal-non-lit-signs-5.jpg?v=1791348118": [735, 490],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-07-2d-metal-non-lit-signs-6.jpg?v=1791348124": [950, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-3.png?v=1791348145": [1537, 1023],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-1.jpg?v=1791348130": [735, 551],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-08-3d-acrylic-frontlit-signs-with-backboard-2.png?v=1791348138": [1448, 1086],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-4.jpg?v=1791348168": [600, 600],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-1.jpg?v=1791348151": [1200, 1600],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-2.jpg?v=1791348157": [1200, 896],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-3.jpg?v=1791348163": [1200, 899],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-09-3d-acrylic-frontlit-signs-with-raceway-5.png?v=1791348176": [1437, 1095],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-2.png?v=1791348190": [1254, 1254],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-1.jpg?v=1791348182": [1200, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-3.png?v=1791348196": [1200, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-10-3d-metal-backlit-signs-with-backboard-4.png?v=1791348204": [1311, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-4.png?v=1791348233": [1254, 1254],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-1.png?v=1791348211": [1136, 1384],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-2.png?v=1791348219": [1159, 1358],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-11-3d-metal-backlit-signs-with-raceway-3.png?v=1791348226": [1254, 1254],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-12-3d-metal-non-lit-signs-with-backboard-2.png?v=1791348246": [1254, 1254],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-storefront-signs-12-3d-metal-non-lit-signs-with-backboard-1.jpg?v=1791348238": [1199, 799],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-card.jpg?v=1791348251": [736, 736],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-01-3d-acrylic-frontlit-signs-3.jpg?v=1791348270": [1200, 900],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-01-3d-acrylic-frontlit-signs-1.jpg?v=1791348257": [1200, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-01-3d-acrylic-frontlit-signs-2.png?v=1791348265": [1254, 1254],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-02-3d-metal-backlit-signs-2.jpg?v=1791348276": [383, 383],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-03-lightbox-signs-1.jpg?v=1791348281": [794, 794],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-03-lightbox-signs-2.jpg?v=1791348287": [736, 736],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-04-push-through-signs-1.jpg?v=1791348293": [739, 415],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-04-push-through-signs-2.jpg?v=1791348298": [650, 450],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-05-3d-metal-non-lit-signs-3.jpg?v=1791348315": [736, 736],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-05-3d-metal-non-lit-signs-1.jpg?v=1791348304": [600, 600],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-05-3d-metal-non-lit-signs-2.jpg?v=1791348309": [736, 736],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-06-flatcut-signs-2.jpg?v=1791348327": [735, 735],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-06-flatcut-signs-1.jpg?v=1791348321": [675, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-06-flatcut-signs-3.jpg?v=1791348333": [736, 1104],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-06-flatcut-signs-4.jpg?v=1791348339": [1200, 1600],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-07-lasercut-signs-1.jpg?v=1791348344": [1024, 768],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-07-lasercut-signs-2.jpg?v=1791348350": [500, 500],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-07-lasercut-signs-3.jpg?v=1791348356": [1122, 1402],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-08-3d-acrylic-frontlit-signs-with-backboard-2.png?v=1791348371": [1254, 1254],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-08-3d-acrylic-frontlit-signs-with-backboard-1.png?v=1791348364": [1542, 1020],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-08-3d-acrylic-frontlit-signs-with-backboard-3.png?v=1791348378": [1594, 987],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-09-3d-metal-backlit-signs-with-backboard-2.png?v=1791348391": [941, 1672],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-09-3d-metal-backlit-signs-with-backboard-1.jpg?v=1791348383": [736, 981],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-09-3d-metal-backlit-signs-with-backboard-3.jpg?v=1791348396": [720, 720],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-3d-interior-signs-09-3d-metal-backlit-signs-with-backboard-4.jpg?v=1791348401": [500, 667],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-outdoor-signs-04-double-sided-light-box-3.jpg?v=1791348419": [1024, 1024],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-outdoor-signs-04-double-sided-light-box-1.jpg?v=1791348408": [736, 1112],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-outdoor-signs-04-double-sided-light-box-2.jpg?v=1791348413": [735, 956],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-outdoor-signs-04-double-sided-light-box-4.jpg?v=1791348425": [1200, 1500],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-card.jpg?v=1791348431": [1024, 1024],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-01-corporate-front-lit-signs-3.jpg?v=1791348449": [735, 410],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-01-corporate-front-lit-signs-1.jpg?v=1791348437": [736, 981],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-01-corporate-front-lit-signs-2.jpg?v=1791348443": [736, 981],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-02-halo-lit-channel-letters-1.jpg?v=1791348454": [736, 1308],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-02-halo-lit-channel-letters-2.jpg?v=1791348460": [1200, 1200],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-03-3d-metal-non-lit-1.jpg?v=1791348467": [1200, 1600],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-04-push-thru-signage-1.png?v=1791348474": [680, 668],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-05-double-sided-light-box-2.jpg?v=1791441393": [1024, 1024],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-05-double-sided-light-box-1.jpg?v=1791348479": [1024, 1024],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-06-corporate-signage-1.png?v=1791348492": [573, 582],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-06-corporate-signage-2.png?v=1791348498": [635, 617],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-07-commercial-signage-1.png?v=1791348506": [1254, 1254],
    "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/sg-corporate-restaurant-signs-10-3d-non-lit-with-backboard-1.png?v=1791348513": [1920, 1080]
  }
};
